import React, { createContext, useState, useEffect } from 'react';
import projectData from '../../data/projects-data/projects.json';

const ProjectContext = createContext();

const ProjectProvider = ({ children }) => {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    setProjects(projectData);
  }, []);

  const selectProject = (id) => {
    const project = projects.find(proj => proj.id === id);
    setSelectedProject(project);
  };

  return (
    <ProjectContext.Provider value={{ projects, selectedProject, selectProject }}>
      {children}
    </ProjectContext.Provider>
  );
};

export { ProjectContext, ProjectProvider };